export function redirectToExternalUrl(url: string): void {
  window.location.href = url;
}
